import React from "react";
import Countdown from "react-countdown";
import { shownText, toPersianNum, toSeperatedNum } from "../../assets/utils";
import { CardColored } from "./reqCardColored.styles";
import FromIcon from "../../assets/img/icn_from_wht.svg";
import ToIcon from "../../assets/img/icn_to_wht.svg";
const ReqCardColored = ({ info }) => {
  // console.log(info);
  // debugger;
  // console.log("driver",info.candidated_driver.deadline_to_confirm);
  let {
    status,
    status_persian,
    source_location,
    destination_location,
    candidated_driver,
    bitting_expires_at,
    // request_type,
    // request_model,
    // weight,
    // weight_unit,
    // loading_description,
    // value,
    // load_type,
    // reuqested_date_persian,
    // created_date_persian,
    vehicle_requested,
    more_destinations,
    // Height,
    // Length,
    // Width,
  } = info;
  console.log("driver", status);
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      // return <Completionist />;
      return <span className="small">به اتمام رسیده</span>;
    } else {
      // Render a countdown
      return (
        <span
          className="d-flex align-items-center justify-content-center"
          style={{ lineHeight: "1em" }}
        >
          <span
            className="bg-white text-dark px-1 border--4 d-flex align-items-center justify-content-between"
            style={{ width: "96px" }}
          >
            <span className="d-flex flex-column" style={{ flexBasis: "30%" }}>
              <span className="font-size--n4 text--blue mb-1">ثانیه</span>
              <span>{toPersianNum(seconds)}</span>
            </span>
            <span className="align-self-end">:</span>
            <span className="d-flex flex-column" style={{ flexBasis: "30%" }}>
              <span className="font-size--n4 text--blue mb-1">دقیقه</span>
              <span>{toPersianNum(minutes)}</span>
            </span>
            <span className="align-self-end">:</span>
            <span className="d-flex flex-column" style={{ flexBasis: "30%" }}>
              <span className="font-size--n4 text--blue mb-1">ساعت</span>
              <span>{toPersianNum(hours)}</span>
            </span>
          </span>
          {!!days && (
            <span className="mr-2 bg-white text-dark px-2 border--4 d-flex flex-column">
              <span className="font-size--n4 text--blue mb-1">روز</span>
              <span>{toPersianNum(days)}</span>
            </span>
          )}
        </span>
      );
    }
  };
  const renderer2 = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      // return <Completionist />;
      return <span className="small">به اتمام رسیده</span>;
    } else {
      // Render a countdown
      return (
        <span style={{ direction: "ltr" }}>
          {
            // toPersianNum(hours)}:{toPersianNum(minutes)}:{toPersianNum(seconds)
            toPersianNum(`${minutes}:${seconds}`)
          }
        </span>
      );
    }
  };

  return (
    <div>
      {/* {console.log(info)} */}
      {info ? (
        <CardColored status={status} className="shadow-sm">
          <div className="d-flex align-items-center">
            <img className="ml-2" src={FromIcon}></img>
            <span className="font-weight-bold font-size--2">{`${source_location._ostan.provincename}، ${source_location._shahr.shahrname}`}</span>
          </div>
          {more_destinations && more_destinations.length > 0 ? (
            <>
              <div className="mt-2 d-flex align-items-center">
                <img className="ml-2" src={ToIcon}></img>
                <span className="font-weight-bold font-size--2">{`${destination_location._ostan.provincename}، ${destination_location._shahr.shahrname}`}</span>
              </div>
              {more_destinations.map((item, index) => (
                <div className=" d-flex align-items-center">
                  <img className="ml-2" src={ToIcon}></img>
                  <span className="font-weight-bold font-size--2">{`${item._ostan.provincename}، ${item._shahr.shahrname}`}</span>
                </div>
              ))}
            </>
          ) : (
            <div className="my-3 d-flex align-items-center">
              <img className="ml-2" src={ToIcon}></img>
              <span className="font-weight-bold font-size--2">{`${destination_location._ostan.provincename}، ${destination_location._shahr.shahrname}`}</span>
            </div>
          )}
          <div className="vehicle font-weight-bold font-size--1 text-center mb-3 mt-2">
            <span>
              {vehicle_requested ? vehicle_requested.v_name : "نامشخص"}
            </span>
          </div>

          {info.status === 2 ? (
            <div className="text-center font-weight-bold font-size--4 mb-3">
              <span>قیمت نهایی:‌ </span>
              <span>{toSeperatedNum(toPersianNum(info.won_price))}</span>
              <span> تومان</span>
            </div>
          ) : null}

          <div className="text-center font-weight-bold font-size--3">
            <span>{status_persian ? status_persian : "نامشخص"}</span>
          </div>
          {status === 0 ? (
            <div className="text-center font-size--3 font-weight-light mt-3 mb-2">
              <Countdown
                date={new Date(bitting_expires_at)}
                renderer={renderer}
              />
            </div>
          ) : null}
          {status === 1 ? (
            <div className=" d-flex text-center font-size--3 font-weight-light mt-3 mb-2 justify-content-around align-center">
              <span className="font-weight-bold ">فرصت راننده برای اعلام آمادگی</span>
              <Countdown
                date={new Date(candidated_driver?.deadline_to_confirm)}
                renderer={renderer2}
              />
            </div>
          ) : null}
        </CardColored>
      ) : null}
    </div>
  );
};

export default ReqCardColored;
